import React from 'react'

const MainPage = () => {
  return (
    <div>
      <div class="title">
        <h1>Welcome to JP's Helping Hand</h1>
      </div>
      <div class="main">
        <div class="menubar">
          <ul>
            <li>
              <a class="active" href="/">
                About Us
              </a>
            </li>
            <li>
              <a href="/TalkingOutLoudforKids">Talking Out loud for Kids</a>
            </li>
            <li>
              <a href="/TalkingOutLoudforEveryone">
                Talking Out loud for Everyone
              </a>
            </li>
            <li>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSf2f6PIk25F9-VIq4bTU1W9HAklzTdDJsJu6O6O506H-NMLng/viewform?usp=sf_link">
                Contact US
              </a>
            </li>
            <li>
              <a href="/PrivacyPolicy">Privacy Policy</a>
            </li>
          </ul>
        </div>

        <p>
          JP’s Helping Hand is a small group of people who want to help disabled
          people. It is meant to improve their lives by creating software for
          everyday activities. For example,{" "}
          <a href="/TalkingOutLoudforKids">Talking Out Loud for Kids</a> is
          a text-to-speech application for those who cannot communicate
          verbally. Or you can try{" "}
          <a href="/TalkingOutLoudforEveryone">
            Talking Out Loud for Everyone
          </a>{" "}
          it's similar to Talking Out Loud for Kids but you could personalize
          it.
        </p>
        <p>
          The founder of JP’s Helping Hand has Cerebral palsy and knows a little
          bit about what it is like to be limited to do something. He wants to
          use what he has experience and learn to help others like him.
        </p>
      </div>
    </div>
  );
}

export default MainPage